import React, { useState, useEffect } from 'react';

// "Every Day's Christmas For My Dog" — everyday commerce (treats, toys, gear, gifts, subscriptions).
// Intentionally shows only real, admin-added products. Never fabricates items.
const EverydayShop = () => {
  const [products, setProducts] = useState([]);
  const [note, setNote] = useState('');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetch('/api/commerce/products?collection=everyday')
      .then(res => res.json())
      .then(data => {
        setProducts(data.products || []);
        setNote(data.note || '');
      })
      .finally(() => setLoading(false));
  }, []);

  return (
    <div className="commerce-panel everyday-shop">
      <h2>🎁 Every Day's Christmas For My Dog</h2>
      <p className="commerce-subtitle">Treats, toys, gear and gifts — personalised to your dog as you add more about them.</p>

      {loading && <p>Loading...</p>}

      {!loading && products.length === 0 && (
        <div className="commerce-empty">
          <p>{note}</p>
        </div>
      )}

      {!loading && products.length > 0 && (
        <div className="commerce-grid">
          {products.map(p => (
            <div key={p.id} className="commerce-card">
              {p.image_url && <img src={p.image_url} alt={p.name} />}
              <h4>{p.name}</h4>
              {p.category && <p className="commerce-category">{p.category}</p>}
              {p.description && <p>{p.description}</p>}
              {p.price_gbp && <p className="commerce-price">£{Number(p.price_gbp).toFixed(2)}</p>}
              {p.product_url && <a href={p.product_url} target="_blank" rel="noopener noreferrer">View</a>}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default EverydayShop;
